<style scoped>
    @import url("../../../styles/smartControl/cardReceita.scss");
</style>

<template>
    <div class="box_cardReceita mt-2">

        <div class="linhaZero">
            <v-chip v-if="controller.t == null" class="ml-1" size="x-small" color="white">
                Atuador sem nome (!)
            </v-chip>
            <v-chip v-else class="ml-1" size="x-small" color="white">
                {{ controller.t }}
            </v-chip>
            <v-icon class="ml-1">mdi-note-edit</v-icon>
        </div>

        <div class="linhaUm">

            <div class="colUm">
                <span :style="{'color':'#F39C12'}">PROGRAMA SELECIONADO PARA ACIONAMENTO:
                    <span :style="{'color':'white'}">{{ controller.p }}</span>
                </span>
            </div>

        </div>

    </div>
</template>

<script>
export default {
    props: ['controller'],
}
</script>
